import { isSuperdrugBrand, thirdPartyBrand } from '@/helpers/env'
import { getUrlLocale } from '@/helpers/url'

export default {
  computed: {
    isSubmitting: function () {
      return this.submitStatus === 'PENDING'
    },
    isSuperdrug () {
      return isSuperdrugBrand()
    },
    validEmail: function () {
      return this.email.toLowerCase().trim()
    },
    isDe: function () {
      return getUrlLocale() === 'de'
    },
    thirdParty: function () {
      return thirdPartyBrand()
    },
    displaySmsOptions: function () {
      return this.phone_number.length > 0
    }
  }
}
